// extracted by mini-css-extract-plugin
export var contactSelection = "kontakt-module--contactSelection--1JUeF";
export var spinAround = "kontakt-module--spinAround--16gpl";